import { useEffect, useState } from 'react';
import { getUnits } from '../constants/helperClient';

// Types for the cleaned areas and unit information
export type CleanedAreasType = {
    [state: string]: {
        [lga: string]: string[];
    };
}[];

export function cleanedAreasToArray(data?: CleanedAreasType) {

    if (!data) return null
    return Object.entries(data).map(([state, lgas]) => ({
        [state]: lgas
    }));
}

export interface UnitInfoType {
    [unitType: string]: string[];
}

// Helper function to convert strings like 'unit_type' to 'unit type'
const convertToCamelCase = (str: string): string => {
    return str
        .replace(/_([a-z])/g, (match, group1) => ` ${group1.toUpperCase()}`)
        .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
}


// UnitsData interface to hold the cleaned areas and unit info
interface UnitsData {
    cleanedAreas: CleanedAreasType;
    unitInfo: UnitInfoType;
}

// Custom hook to fetch and manage units data
const useUnitsData = () => {
    const [unitsData, setUnitsData] = useState<UnitsData | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadUnits = async () => {
            try {
                setLoading(true);  // Set loading state to true when the data is being fetched
                setError(null);    // Reset any previous errors
                const { cleanedAreas, unitInfo } = await getUnits(); // Fetch data using getUnits
                // Clean the keys in unitInfo by converting them to camelCase
                const cleanedUnitInfo: UnitInfoType = Object.keys(unitInfo).reduce((acc, key) => {
                    const camelCaseKey = convertToCamelCase(key);
                    acc[camelCaseKey] = unitInfo[key];
                    return acc;
                }, {} as UnitInfoType);



                // Clean the keys in cleanedAreas (it's an object, not an array)
                // const cleanedCleanedAreas: CleanedAreasType = Object.entries(cleanedAreas).reduce(
                //     (acc, [state, lgas]) => {
                //         const cleanedState = convertToCamelCase(state);
                //         acc[cleanedState as unknown as number] = lgas;
                //         return acc;
                //     },
                //     {} as CleanedAreasType
                // );
                



                // Store the cleaned data in state
                setUnitsData({ cleanedAreas: cleanedAreas, unitInfo: cleanedUnitInfo });

            } catch (err) {
                // Handle error and set error state
                console.error("Failed to load unit data:", err);
                setError("Failed to load unit data");
            } finally {
                // Set loading to false after data is fetched or on error
                setLoading(false);
            }
        };

        loadUnits();
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    // Return the units data, loading state, and error message
    return { unitsData, loading, error };
};

export default useUnitsData;
